// ofuro-wiki: No per-user storage quota display
export const CloudUsage = () => {
  return null;
};
